module.exports = __webpack_public_path__ + "static/man-me-2fcef71dcfe2dac6d678df610c26afc8.jpg";